import { Component } from "react"
import PropTypes from "prop-types"

import ServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"

class GetMoreServiceCard extends Component {
  render() {
    return (
      <li
        ref={el => {
          this.scrollObserverEl = el
        }}
        className="service-card-list-item"
      >
        <ServiceCard service={this.props.service} path={`/${this.props.service.module_name}`} />
      </li>
    )
  }
}

GetMoreServiceCard.propTypes = {
  service: serviceShape.isRequired,
  position: PropTypes.number.isRequired,
}

GetMoreServiceCard.defaultProps = {
  service: {},
}

export default GetMoreServiceCard
